import {
  Dialog,
  OptionsSelectField,
  SubmissionForm,
  IDialogProps,
  Option
} from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { BpIdUserDto, UserGroupDto } from "@libs/api/gateways/bp-id/bp-id.dtos";
import { useGetAllGroups } from "@libs/api/gateways/bp-id/bp-id.hooks";

interface Props extends IDialogProps {
  user: BpIdUserDto | undefined;
  userGroups: UserGroupDto[] | undefined;
  onUpdate: (
    userId: string,
    addGroupIds: string[],
    removeGroupIds: string[]
  ) => void;
}

interface AddGroupValues {
  userGroups: string[];
}

export const UserGroupDialog = ({
  user: currentUser,
  userGroups: currentGroups,
  onUpdate,
  onDismiss,
  ...modalProps
}: Props) => {
  const { isLoading, error, data } = useGetAllGroups();

  const allGroups: UserGroupDto[] = data?.groups || [];
  const originalGroups = currentGroups?.map(x => x.id) ?? [];

  const onSubmit = async (values: AddGroupValues) => {
    const addGroups = values.userGroups.filter(
      g => originalGroups.indexOf(g) < 0
    );

    const removeGroups = originalGroups.filter(
      g => values.userGroups.indexOf(g) < 0
    );

    onUpdate(currentUser?.id ?? "", addGroups, removeGroups);
    onDismiss?.();
  };

  const defaultValues: AddGroupValues = {
    userGroups: currentGroups?.map(x => x.displayName) || []
  };

  const groupOptions: Option[] = allGroups.map(g => ({
    key: g.id,
    text: g.displayName,
    selected: currentGroups?.some(x => x.id === g.id)
  }));

  return (
    <Dialog
      dialogContentProps={{
        title: "Add Group To User",
        showCloseButton: true,
        onDismiss
      }}
      minWidth="400px"
      maxWidth="400px"
      {...modalProps}
    >
      <QueryStateIndicator<UserGroupDto[]>
        {...useGetAllGroups}
        isLoading={isLoading}
        error={error}
        data={allGroups}
      >
        <SubmissionForm<AddGroupValues>
          initialValues={defaultValues}
          onSubmit={onSubmit}
          cancelButtonProps={{ onClick: () => onDismiss?.() }}
        >
          {() => {
            return (
              <OptionsSelectField
                name="userGroups"
                placeholder="Select Group"
                label="Groups"
                multiSelect
                required
                options={groupOptions}
              />
            );
          }}
        </SubmissionForm>
      </QueryStateIndicator>
    </Dialog>
  );
};
